import React from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import InformacoesGerais from "../../../components/Authenticated/MinhaConta/InformacoesGerais";

function TermosDeUso() {
  const navigate = useNavigate()
  const Voltar = () => {
    navigate("/area-restrita/");
  };

  return (
    <>
    <div className="bg-white">
        <button
          onClick={Voltar}
          className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9 h-9 hover:bg-[#00575e] transition"
        >
          <ChevronLeft size={20} color="#fff" />
        </button>
      <div className="w-full min-h-screen overflow-y-auto">
        <div className="px-4 py-10 sm:py-4 max-w-3xl mx-auto mb-[50px] sm:mb-0">
          <p>
            Bem-vindo ao aplicativo do Instituto Selma Cosso! Estes termos de uso regem o uso do nosso aplicativo. Ao acessar ou usar este aplicativo, você concorda com estes termos de uso.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">1. Uso Aceitável</h2>
          <p className="text-justify">
            1.1. Você concorda em usar este aplicativo apenas para fins legais e de acordo com estes termos de uso. <br />
            1.2. Você concorda em não usar este aplicativo de qualquer forma que possa danificar, desabilitar, sobrecarregar ou prejudicar o funcionamento do aplicativo.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">2. Conteúdo e Propriedade Intelectual</h2>
          <p className="text-justify">
            2.1. Todo o conteúdo disponível neste aplicativo, incluindo textos, gráficos, logotipos, ícones, imagens, clipes de áudio e vídeo, downloads digitais e dados compilados, é propriedade do Instituto Selma Cosso ou de seus licenciadores e está protegido por leis de direitos autorais e outras leis de propriedade intelectual. <br />
            2.2. Você concorda em não reproduzir, distribuir, modificar, criar obras derivadas, exibir publicamente, realizar publicamente, republicar, baixar, armazenar ou transmitir qualquer conteúdo disponível neste aplicativo, exceto conforme expressamente autorizado por nós.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">3. Privacidade</h2>
          <p className="text-justify">
            3.1. O uso deste aplicativo está sujeito à nossa Política de Privacidade, que descreve nossas práticas de coleta, uso, armazenamento e divulgação de informações pessoais. Ao usar este aplicativo, você concorda com o processamento de suas informações pessoais de acordo com nossa Política de Privacidade.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">4. Limitação de Responsabilidade</h2>
          <p className="text-justify">
            4.1. O Instituto Selma Cosso não será responsável por quaisquer danos diretos, indiretos, incidentais, consequentes, especiais ou punitivos decorrentes do uso ou incapacidade de usar este aplicativo.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">5. Alterações nos Termos de Uso</h2>
          <p className="text-justify">
            5.1. O Instituto Selma Cosso reserva-se o direito de atualizar ou modificar estes termos de uso a qualquer momento sem aviso prévio. O uso contínuo deste aplicativo após quaisquer alterações nos termos de uso constituirá sua aceitação dessas alterações.
          </p>

          <h2 className="text-lg font-bold mt-4 mb-2">6. Contato</h2>
          <p className="text-justify">
            6.1. Se você tiver alguma dúvida ou preocupação sobre estes termos de uso, entre em contato conosco pelo e-mail:{" "}
            <a href="mailto:suporte@institutoselmacosso.com.br" className="text-blue-600 underline">
              suporte@institutoselmacosso.com.br
            </a>
          </p>
          <InformacoesGerais />
        </div>
      </div>
    </div>
    </>
  );
}

export default TermosDeUso;
